// 银行卡识别字段
const bankcardColumns = [
  {
    key: 'num',
    name: '银行卡号',
    editable: true
  },
  {
    key: 'bank',
    name: '银行名称'
  },
  {
    key: 'expired',
    name: '有效期'
  },
  {
    key: 'type',
    name: '卡片类型'
  }
]
// 医疗票据识别字段
const medicalInvoiceColumns = [{
  key: 'name',
  name: '姓名',
  editable: true
}, {
  key: 'fapiaohao',
  name: '发票号',
  required: true,
  editable: true
}, {
  key: 'time',
  name: '发票时间',
  editable: true,
  type: 'DatePicker'
}, {
  key: 'piaomianjine',
  name: '票面金额',
  type: 'number',
  required: true,
  editable: true
}, {
  key: 'tongchouzhifu',
  name: '统筹支付',
  type: 'number',
  editable: true
}, {
  key: 'yileizifei',
  name: '乙类自费',
  type: 'number',
  editable: true
}, {
  key: 'bingleizifei',
  name: '丙类自费',
  type: 'number',
  editable: true
}, {
  key: 'fujiazhifu',
  name: '附加支付',
  editable: true
}, {
  key: 'qitakouchu',
  name: '其他扣除',
  type: 'number',
  editable: true
}, {
  key: 'buhelikouchu',
  name: '不合理扣除',
  type: 'number',
  editable: true
}, {
  key: 'sunshijine',
  name: '损失金额',
  type: 'number',
  editable: true,
  disabled: true
}, {
  key: 'remark',
  name: '备注',
  editable: true
}]
// 标的识别枚举
export const targetOcrTypes = [{
  label: '银行卡识别',
  value: 'bankcard',
  columns: bankcardColumns
}, {
  label: '医疗发票识别',
  value: 'medical',
  columns: medicalInvoiceColumns
}]
// 三者识别类型枚举
export const thirdPartyOcrTypes = [
  {
    value: 'driving',
    label: '驾驶证识别',
    columns: [
      {
        key: 'name',
        name: '姓名',
        editable: true
      },
      {
        key: 'sex',
        name: '性别'
      },
      {
        key: 'id',
        name: '证件号',
        editable: true
      },
      {
        key: 'nation',
        name: '国籍'
      },
      {
        key: 'address',
        name: '住址'
      },
      {
        key: 'birthday',
        name: '出生日期'
      },
      {
        key: 'getDate',
        name: '领证日期'
      },
      {
        key: 'driveType',
        name: '准驾车型'
      },
      {
        key: 'start',
        name: '有效期开始'
      },
      {
        key: 'expired',
        name: '有效期结束'
      }
    ]
  },
  {
    value: 'vehicle',
    label: '行驶证识别',
    columns: [
      {
        key: 'carNum',
        name: '车牌号',
        editable: true
      },
      {
        key: 'carType',
        name: '车辆类型'
      },
      {
        key: 'owner',
        name: '所有人',
        editable: true
      },
      {
        key: 'address',
        name: '住址'
      },
      {
        key: 'use',
        name: '使用性质'
      },
      {
        key: 'brand',
        name: '品牌型号'
      },
      {
        key: 'code',
        name: '车辆识别码',
        editable: true
      },
      {
        key: 'engineNum',
        name: '发动机号'
      },
      {
        key: 'recordDate',
        name: '注册日期'
      },
      {
        key: 'certificateDate',
        name: '发证日期'
      }
    ]
  },
  {
    value: 'idcard',
    label: '身份证识别',
    columns: [
      {
        key: 'name',
        name: '姓名',
        editable: true
      },
      {
        key: 'sex',
        name: '性别'
      },
      {
        key: 'nation',
        name: '民族'
      },
      {
        key: 'birth',
        name: '出生日期'
      },
      {
        key: 'id',
        name: '身份证号',
        editable: true
      },
      {
        key: 'address',
        name: '地址'
      }
    ]
  },
  {
    value: 'bankcard',
    label: '银行卡识别',
    columns: bankcardColumns
  }, {
    label: '医疗发票识别',
    value: 'medical',
    columns: medicalInvoiceColumns
  }
];
